(function () {
  const PHOTO_UPLOAD_ENDPOINT = 'https://tfx-photo-upload.young-sky-a2c1.workers.dev';
  const PHOTO_FIELDS = ['head_circumference', 'head_width', 'face_circumference'];
  const qs = (root, selector) => root.querySelector(selector);
  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[character]));
  const shellFromText = (value) => {
    const match = String(value || '').match(/Shell\s+(00|0|1|2|3)/i);
    return match ? `Shell ${match[1]}` : '';
  };

  function init(root) {
    const dataScript = qs(root, '[data-tfx-stock-data]');
    const status = qs(root, '[data-tfx-stock-status]');
    const list = qs(root, '[data-tfx-stock-cards]');
    const purchasePanel = qs(root, '[data-tfx-stock-purchase]');
    const selectedImage = qs(root, '[data-tfx-stock-selected-image]');
    const selectedKicker = qs(root, '[data-tfx-stock-selected-kicker]');
    const selectedTitle = qs(root, '[data-tfx-stock-selected-title]');
    const selectedMeta = qs(root, '[data-tfx-stock-selected-summary]');
    const selectedPrice = qs(root, '[data-tfx-stock-selected-price]');
    const totalNote = qs(root, '[data-tfx-stock-total-note]');
    const fit = qs(root, '[data-tfx-stock-fit]');
    const fitModeInputs = qsa(root, '[data-tfx-fit-mode]');
    const knownPanel = qs(root, '[data-tfx-fit-known]');
    const photoPanel = qs(root, '[data-tfx-fit-photos]');
    const confirmInput = qs(root, '[data-tfx-fit-confirm]');
    const centralSelect = qs(root, '[data-tfx-central-select]');
    const sideSelect = qs(root, '[data-tfx-side-select]');
    const addButton = qs(root, '[data-tfx-stock-add]');
    const cartNote = qs(root, '[data-tfx-stock-cart-note]');

    if (!dataScript || !status || !list || !purchasePanel || !selectedImage || !fit || !knownPanel || !photoPanel || !confirmInput || !centralSelect || !sideSelect || !addButton) return;

    let data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (error) {
      status.textContent = 'Stock helmet data could not be loaded.';
      return;
    }

    const previewUnavailable = root.dataset.showUnavailablePreview === 'true';
    const allStock = (data.stockVariants || []).map((variant) => ({
      ...variant,
      shell: variant.shell || shellFromText(variant.title)
    }));
    const central = (data.centralVariants || []).map((variant) => ({
      ...variant,
      shell: variant.shell || shellFromText(variant.title)
    }));
    const side = (data.sideVariants || []).map((variant) => ({
      ...variant,
      shell: variant.shell || shellFromText(variant.title)
    }));

    const availableStock = allStock.filter((variant) => variant.available);
    let renderedStock = availableStock;
    let previewSamples = false;

    if (!renderedStock.length && previewUnavailable) {
      previewSamples = true;
      const seenShells = new Set();
      renderedStock = allStock.filter((variant) => {
        if (seenShells.has(variant.shell)) return false;
        seenShells.add(variant.shell);
        return true;
      }).slice(0, 4);
      status.innerHTML = '<span class="tfx-stock__mode">Preview</span><span>Four sample helmets are shown for layout and fit testing.</span>';
    } else if (renderedStock.length) {
      status.innerHTML = `<span class="tfx-stock__mode tfx-stock__mode--live">In stock</span><span>${renderedStock.length} helmet${renderedStock.length === 1 ? '' : 's'} available now.</span>`;
    } else {
      status.innerHTML = '<span class="tfx-stock__mode">No stock</span><span>Available helmets will appear here automatically when inventory is received.</span>';
    }

    const optionHTML = (items) => items.map((item) => `<option value="${escapeHTML(item.id)}">${escapeHTML(item.title)}</option>`).join('');
    const compatible = (items, shell) => {
      if (previewSamples) return items.filter((variant) => variant.shell === shell);
      return items.filter((variant) => variant.shell === shell && variant.available);
    };

    let selectedStock = null;
    const uploadedPhotos = Object.fromEntries(PHOTO_FIELDS.map((field) => [field, []]));
    const activeUploads = new Set();

    const currentFitMode = () => fitModeInputs.find((input) => input.checked)?.value || '';
    const selectedCentral = () => central.find((variant) => String(variant.id) === String(centralSelect.value));
    const selectedSide = () => side.find((variant) => String(variant.id) === String(sideSelect.value));
    const photoReviewComplete = () => PHOTO_FIELDS.every((field) => uploadedPhotos[field].length > 0);

    function cardLabel(variant) {
      return `${variant.shell}, ${variant.finish}, ${variant.logo} logo, ${variant.price}`;
    }

    list.innerHTML = renderedStock.map((variant) => `
      <button type="button" class="tfx-stock-item${previewSamples ? ' tfx-stock-item--sample' : ''}" data-stock-id="${escapeHTML(variant.id)}" aria-pressed="false" aria-label="Choose ${escapeHTML(cardLabel(variant))}">
        <span class="tfx-stock-item__thumb">${variant.image ? `<img src="${escapeHTML(variant.image)}" alt="" loading="lazy">` : ''}</span>
        <span class="tfx-stock-item__content">
          <span class="tfx-stock-item__shell">${escapeHTML(variant.shell || 'Stock shell')}</span>
          <strong>${escapeHTML(variant.finish || variant.title)}</strong>
          <span>${escapeHTML(variant.logo || '—')} logo</span>
        </span>
        <span class="tfx-stock-item__end">
          <strong>${escapeHTML(variant.price || '')}</strong>
          <span class="tfx-stock-item__badge">${previewSamples ? 'Sample' : 'In stock'}</span>
          <span class="tfx-stock-item__select">${previewSamples ? 'Preview fit' : 'Select'} →</span>
        </span>
      </button>
    `).join('');

    if (!renderedStock.length) {
      list.innerHTML = '<div class="tfx-stock__empty"><strong>No stock TFX helmets are available right now.</strong><p>When inventory is received, the exact available helmet combinations will appear here.</p></div>';
    }

    const defaultVisual = renderedStock.find((variant) => variant.image)?.image || allStock.find((variant) => variant.image)?.image;
    if (defaultVisual) {
      selectedImage.src = defaultVisual;
      selectedImage.alt = 'Tonfly TFX stock helmet';
    }

    function syncFitMode() {
      const mode = currentFitMode();
      knownPanel.hidden = mode !== 'known';
      photoPanel.hidden = mode !== 'photos';
      qsa(root, '[data-tfx-fit-mode-card]').forEach((card) => {
        const input = qs(card, '[data-tfx-fit-mode]');
        card.classList.toggle('is-selected', Boolean(input?.checked));
      });
      updateAddState();
    }

    function updateAddState() {
      const mode = currentFitMode();
      const centralVariant = selectedCentral();
      const sideVariant = selectedSide();
      const helmetAvailable = Boolean(selectedStock?.available);
      let canAdd = false;
      addButton.disabled = true;

      if (!selectedStock) {
        addButton.textContent = 'Choose a helmet to continue';
        totalNote.textContent = 'Fit setup follows after helmet selection';
        cartNote.textContent = 'Choose the exact stock helmet first.';
        return;
      }

      if (!mode) {
        addButton.textContent = 'Choose how to confirm the fit';
        totalNote.textContent = 'Choose your liner sizes or upload sizing photos';
        cartNote.textContent = 'Choose your liner sizes or upload photos for sizing help.';
        return;
      }

      if (mode === 'known') {
        totalNote.textContent = 'Central + side liners included';
        const linersAvailable = Boolean(centralVariant?.available && sideVariant?.available);
        canAdd = helmetAvailable && linersAvailable && confirmInput.checked;
        if (!confirmInput.checked) {
          addButton.textContent = 'Confirm your liner selection to continue';
          cartNote.textContent = 'Confirm that you know your shell and liner sizing before adding the package.';
        } else if (!linersAvailable && !previewSamples) {
          addButton.textContent = 'Selected liner size unavailable';
          cartNote.textContent = 'One of your selected liner sizes is currently unavailable.';
        } else {
          addButton.textContent = `Add stock TFX package — ${selectedStock.price}`;
          cartNote.textContent = 'Your selected central and side liners are included.';
        }
      }

      if (mode === 'photos') {
        totalNote.textContent = 'Sizing reviewed with Tonfly';
        canAdd = helmetAvailable && photoReviewComplete() && activeUploads.size === 0;
        if (activeUploads.size) {
          addButton.textContent = 'Please wait — photos are uploading';
          cartNote.textContent = 'Please wait until every photo finishes uploading.';
        } else if (!photoReviewComplete()) {
          addButton.textContent = 'Upload the three required photo groups';
          cartNote.textContent = 'Upload each required photo so we can review your fit with Tonfly.';
        } else {
          addButton.textContent = `Add stock TFX to cart — ${selectedStock.price}`;
          cartNote.textContent = 'We’ll review your photos and confirm the best fit.';
        }
      }

      if (previewSamples && !helmetAvailable) {
        canAdd = false;
        if ((mode === 'known' && confirmInput.checked) || (mode === 'photos' && photoReviewComplete() && !activeUploads.size)) {
          addButton.textContent = 'Add to cart when inventory is available';
          cartNote.textContent = 'Preview only: the fit flow works, but the cart stays disabled while helmet inventory is 0.';
        }
      }

      addButton.disabled = !canAdd;
    }

    function selectStock(variant) {
      selectedStock = variant;
      qsa(list, '[data-stock-id]').forEach((card) => card.setAttribute('aria-pressed', String(card.dataset.stockId === String(variant.id))));

      const centralOptions = compatible(central, variant.shell);
      const sideOptions = compatible(side, variant.shell);

      if (variant.image) {
        selectedImage.src = variant.image;
        selectedImage.alt = variant.title;
      }
      selectedKicker.textContent = variant.shell;
      selectedTitle.textContent = variant.finish;
      selectedMeta.innerHTML = `<span>${escapeHTML(variant.logo)} logo</span><span>${escapeHTML(variant.shell)}</span>`;
      selectedPrice.textContent = variant.price;

      centralSelect.innerHTML = centralOptions.length
        ? optionHTML(centralOptions)
        : '<option value="">No compatible central liner in stock</option>';
      sideSelect.innerHTML = sideOptions.length
        ? optionHTML(sideOptions)
        : '<option value="">No compatible side liner in stock</option>';

      confirmInput.checked = false;
      fit.hidden = false;
      purchasePanel.classList.add('is-selected');
      updateAddState();

      if (window.matchMedia('(max-width: 860px)').matches) {
        purchasePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    async function uploadPhoto(file, field) {
      const signingResponse = await fetch(PHOTO_UPLOAD_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: file.name, folder: `tfx-stock-fit-review/${field}` })
      });
      if (!signingResponse.ok) throw new Error(`Upload signing failed (${signingResponse.status})`);
      const { url, fields } = await signingResponse.json();
      const form = new FormData();
      Object.entries(fields).forEach(([key, value]) => form.append(key, value));
      form.append('file', file);
      const uploadResponse = await fetch(url, { method: 'POST', body: form });
      if (!uploadResponse.ok) throw new Error(`Photo upload failed (${uploadResponse.status})`);
      const result = await uploadResponse.json();
      if (!result.secure_url) throw new Error('Photo URL missing from upload response');
      return result.secure_url;
    }

    qsa(root, '[data-tfx-photo-input]').forEach((input) => {
      input.addEventListener('change', async () => {
        const field = input.dataset.tfxPhotoInput;
        const row = input.closest('[data-tfx-photo-row]');
        const statusText = qs(row, '[data-tfx-photo-status]');
        const files = Array.from(input.files || []);
        if (!field || !files.length) return;

        uploadedPhotos[field] = [];
        activeUploads.add(field);
        input.disabled = true;
        row.dataset.uploadState = 'uploading';
        statusText.textContent = `Uploading ${files.length === 1 ? files[0].name : `${files.length} photos`}…`;
        updateAddState();

        try {
          uploadedPhotos[field] = await Promise.all(files.map((file) => uploadPhoto(file, field)));
          row.dataset.uploadState = 'success';
          statusText.textContent = `${files.length} photo${files.length === 1 ? '' : 's'} uploaded`;
        } catch (error) {
          uploadedPhotos[field] = [];
          row.dataset.uploadState = 'error';
          statusText.textContent = 'Upload failed — choose the photo again';
          input.value = '';
        } finally {
          activeUploads.delete(field);
          input.disabled = false;
          updateAddState();
        }
      });
    });

    list.addEventListener('click', (event) => {
      const card = event.target.closest('[data-stock-id]');
      if (!card) return;
      const variant = allStock.find((item) => String(item.id) === String(card.dataset.stockId));
      if (variant) selectStock(variant);
    });

    fitModeInputs.forEach((input) => input.addEventListener('change', syncFitMode));
    confirmInput.addEventListener('change', updateAddState);
    centralSelect.addEventListener('change', () => {
      confirmInput.checked = false;
      updateAddState();
    });
    sideSelect.addEventListener('change', () => {
      confirmInput.checked = false;
      updateAddState();
    });

    addButton.addEventListener('click', async () => {
      const mode = currentFitMode();
      const centralVariant = selectedCentral();
      const sideVariant = selectedSide();
      if (!selectedStock || addButton.disabled || !mode) return;
      if (mode === 'known' && (!centralVariant || !sideVariant || !confirmInput.checked)) return;
      if (mode === 'photos' && !photoReviewComplete()) return;

      addButton.disabled = true;
      addButton.textContent = 'Adding stock TFX…';
      cartNote.textContent = 'Preparing the order details…';
      const bundleKey = `tfx-stock-${Date.now()}`;
      const helmetProperties = {
        'Stock helmet': selectedStock.title,
        'Requested shell': selectedStock.shell,
        '_tfx_stock_bundle': bundleKey
      };
      const items = [];

      if (mode === 'known') {
        helmetProperties['Fit selection'] = 'I know my shell and liner size';
        helmetProperties['Central liner'] = centralVariant.title;
        helmetProperties['Side liner'] = sideVariant.title;
        helmetProperties['_fit_review_mode'] = 'customer_confirmed';
        items.push(
          { id: Number(selectedStock.id), quantity: 1, properties: helmetProperties },
          { id: Number(centralVariant.id), quantity: 1, properties: { '_included_with': 'Tonfly TFX stock helmet', '_tfx_stock_bundle': bundleKey } },
          { id: Number(sideVariant.id), quantity: 1, properties: { '_included_with': 'Tonfly TFX stock helmet', '_tfx_stock_bundle': bundleKey } }
        );
      }

      if (mode === 'photos') {
        helmetProperties['Fit selection'] = 'Review my photos';
        helmetProperties['_fit_review_mode'] = 'photos';
        const orderedPhotoUrls = [
          ...uploadedPhotos.head_circumference,
          ...uploadedPhotos.head_width,
          ...uploadedPhotos.face_circumference
        ];
        orderedPhotoUrls.forEach((url, index) => {
          helmetProperties[`_Photo ${index + 1}`] = url;
        });
        items.push({ id: Number(selectedStock.id), quantity: 1, properties: helmetProperties });
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(await response.text());
        addButton.textContent = 'Added to cart';
        cartNote.textContent = mode === 'photos'
          ? 'Added to cart. Your photos are attached for sizing review.'
          : 'The stock TFX package is now in your cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        addButton.disabled = false;
        addButton.textContent = mode === 'photos'
          ? `Add stock TFX to cart — ${selectedStock.price}`
          : `Add stock TFX package — ${selectedStock.price}`;
        cartNote.textContent = 'Could not add this item. Please check inventory and try again.';
      }
    });

    syncFitMode();
  }

  function initQuickActions(nav) {
    const hero = document.querySelector('.tfx-hero');
    const configurator = document.querySelector('[data-tfx-configurator-root]');
    const stock = document.querySelector('[data-tfx-stock-root]');
    const footer = document.querySelector('footer');
    const hasStockRoute = nav.dataset.hasStock === 'true';

    const isInView = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.88 && rect.bottom > window.innerHeight * 0.12;
    };

    const ownsViewportCenter = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const center = window.innerHeight * 0.5;
      return rect.top <= center && rect.bottom >= center;
    };

    const update = () => {
      const threshold = hero
        ? hero.offsetTop + Math.min(hero.offsetHeight * 0.72, 560)
        : 0;
      let context = 'both';

      if (ownsViewportCenter(stock)) {
        context = 'stock';
      } else if (ownsViewportCenter(configurator)) {
        context = 'configurator';
      }

      nav.dataset.context = context;
      nav.setAttribute('aria-label', !hasStockRoute
        ? 'Configure your Tonfly TFX'
        : context === 'stock'
          ? 'Switch to custom TFX configuration'
          : context === 'configurator'
            ? 'Switch to stock TFX helmets'
            : 'Tonfly TFX purchase options');

      const shouldShow = window.scrollY > threshold
        && context !== 'stock'
        && !(context === 'configurator' && !hasStockRoute)
        && !isInView(footer);
      nav.classList.toggle('is-visible', shouldShow);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-tfx-stock-root]').forEach(init);
    document.querySelectorAll('[data-tfx-quick-actions]').forEach(initQuickActions);
  });
})();
